export const BUDGET_CODES = [
  {
    "code": "B009",
    "label": "～500円",
    "min" : 0,
    "max" : 500
  },
  {
    "code": "B010",
    "label": "501～1000円",
    "min" : 500,
    "max" : 1000
  },
  {
    "code": "B011",
    "label": "1001～1500円",
    "min" : 1000,
    "max" : 1500
  },
  {
    "code": "B001",
    "label": "1501～2000円",
    "min" : 1500,
    "max" : 2000
  },
  {
    "code": "B002",
    "label": "2001～3000円",
    "min" : 2000,
    "max" : 3000
  },
  {
    "code": "B003",
    "label": "3001～4000円",
    "min" : 3000,
    "max" : 4000
  },
  {
    "code": "B008",
    "label": "4001～5000円",
    "min" : 4000,
    "max" : 5000
  }
]


export const GENRE_CODES = {
  "G001": "居酒屋",
  "G002": "ダイニングバー・バル",
  "G003": "創作料理",
  "G004": "和食",
  "G005": "洋食",
  "G006": "イタリアン・フレンチ",
  "G007": "中華",
  "G008": "焼肉・ホルモン",
  "G017": "韓国料理",
  "G009": "アジア・エスニック料理",
  "G010": "各国料理",
  "G011": "カラオケ・パーティ",
  "G012": "バー・カクテル",
  "G013": "ラーメン",
  "G016": "お好み焼き・もんじゃ",
  "G014": "カフェ・スイーツ",
  "G015": "その他グルメ"
}


